import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Markdown from 'markdown-to-jsx';

import Card from "../../../../Components/UI/Card/Card";

import { configActions } from '../../../../lib/configStore';

import styles from "./InfoTab.module.css";

const errorText = `Error: No text available. Please define the infoText in the admin panel.`;

const InfoTab = (props) => {
  const configData = useSelector(state => state.config.data);

  useEffect(() => { props.onValidChange(true); }, []);   

  return (
    <Card className={styles.infoCard}>
      <div style={{ lineHeight: "130%" }}>
        <Markdown>{ configData.infoText || errorText }</Markdown>
      </div>
    </Card>
  );
};

export default InfoTab;
